import Header from '../components/Header'
import Navbar from '../components/Navbar'
import { TREATMENT, PATIENT } from '../services/routes'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'
import NumberFormat from 'react-number-format'
import Modal from 'react-modal'
import { Footer } from '../components/Footer'

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        minWidth: '500px',
        bottom: 'auto',
        marginRight: '-50%',
        backgroundColor: 'white',
        transform: 'translate(-50%, -50%)',
    },
};

const NewTreatment = () => {

    const { id } = useParams()

    const token = localStorage.getItem('token')

    const [patient, setPatient] = useState('')
    const [patientName, setPatientName] = useState('')
    const [patientData, setPatientData] = useState()
    const [searchPatient, setSearchPatient] = useState('')
    const [date, setDate] = useState('')
    const [procedure, setProcedure] = useState('')
    const [fee, setFee] = useState('')
    const [formOfPayment, setFormOfPayment] = useState('')
    const [company, setCompany] = useState('')
    const [cid, setCid] = useState('')
    const [annotation, setAnnotation] = useState('')
    const [report, setReport] = useState('')
    const [doctor, setDoctor] = useState('')
    const [patients, setPatients] = useState([])

    const [modalIsOpen, setIsOpen] = useState(false);
    const [showPostModal, setShowPostModal] = useState(false)

    const getPatient = async () => {
        await axios.get(`${PATIENT.GETALL}`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(json => {
                console.log(json.data.patient)
                setPatients(json.data.patient)
            })
            .catch(err => {
                console.error(err)
            })
    }

    const formatDate = item => {
        let date = new Date(item)
        let day = date.getDate() + 1 < 10 ? `0${date.getDate() + 1}` : date.getDate() + 1
        let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
        let year = date.getFullYear()

        return `${year}-${month}-${day}`
    }

    const getTreatmentId = async () => {
        let data

        if (id) {
            await axios.get(TREATMENT.GET.replace(/:id/gi, id), {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => {
                    data = res.data.treatment
                    console.log('treatmentId ', data)
                    setPatient(data.patient)
                    getPatientId(data.patient)
                    setDate(formatDate(data.date))
                    setProcedure(data.procedure)
                    setFee(data.fee)
                    setCompany(data.company)
                    setFormOfPayment(data.formOfPayment)
                    setAnnotation(data.annotation)
                    setReport(data.report)
                    setCid(data.cid)
                    setDoctor(data.doctor)
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }

    const getPatientId = async (patientId) => {
        if (patientId) {

            await axios.get(PATIENT.GET.replace(/:id/gi, patientId), {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => {
                    console.log('patientId ', res.data.patient)
                    setPatientData(res.data.patient)
                    setPatientName(`${res.data.patient.name} ${res.data.patient.lastname}`)
                })
        }
    }

    const togglePostModal = () => {
        setIsOpen(!modalIsOpen);
        setShowPostModal(!showPostModal)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (id) {
            await axios.put(TREATMENT.UPDATE.replace(/:id/gi, id), {
                patient,
                date,
                procedure,
                fee,
                formOfPayment,
                company,
                cid,
                annotation,
                report,
                doctor
            }, {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => {
                    console.log(res)
                    toast.success('Atendimento atualizado')
                })
                .catch(err => {
                    console.log(err)
                    toast.error('Erro ao atualizar')
                })
            return;
        }

        await axios.post(`${TREATMENT.CREATE}`, {
            patient,
            date,
            procedure,
            fee,
            formOfPayment,
            company,
            cid,
            annotation,
            report,
            doctor
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((json) => {
            toast.success('Atendimento feito!')
            console.log(json)
        }).catch(err => {
            toast.error('Erro ao criar, confira os campos obrigatórios.')
            console.error(err)
        })
    }

    useEffect(() => {

        getPatient();
        getTreatmentId()

    }, [searchPatient])

    return (
        <>
            <Helmet>
                <title>Novo atendimento - Coluço System</title>
            </Helmet>
            <div id="wrapper">

                {showPostModal && <Modal
                    ariaHideApp={false}
                    isOpen={modalIsOpen}
                    onRequestClose={togglePostModal}
                    style={customStyles}
                    contentLabel="Seleção de paciente"
                >
                    <input
                        className="form-control mb-2"
                        list="dataListPatient"
                        onChange={e => setSearchPatient(e.target.value)}
                        placeholder="Digite o nome ou CPF para pesquisar"
                    />
                    {patients.filter(item => {
                        if (searchPatient === '') {
                            return ''
                        } else if (item.name.toLowerCase().includes(searchPatient.toLowerCase()) || item.cpf.includes(searchPatient.toLowerCase())) {
                            return item
                        }
                    }).map((item, index) => {
                        return (
                            <div className="d-grid gap-2">
                                <button key={index} type="button" onClick={() => {
                                    setPatient(item._id)
                                    setPatientName(`${item.name} ${item.lastname}`)
                                    togglePostModal()
                                    setSearchPatient('')
                                }} className="btn btn-light">{item.name} {item.lastname} <br /> {item.cpf}</button>
                            </div>
                        )
                    })}

                </Modal>}

                <Header active="newTreatment" />

                <div id="content-wrapper" className="d-flex flex-column">

                    <div id="content">

                        <Navbar />

                        <div className="container-fluid">

                            <h1 className="h3 mb-2 text-gray-800">Novo Atendimento</h1>

                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">Cadastrar um novo atendimento</h6>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-row">
                                                    <div className="col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label">Paciente *</label> <br />
                                                            <div className="d-grid gap-2">
                                                                {id ? (
                                                                    <button disabled type="button" className="btn btn-outline-secondary" onClick={() => togglePostModal()}>{patient !== '' ? patientName : 'Selecione um paciente'}</button>
                                                                ) : (
                                                                    <button type="button" className="btn btn-outline-secondary" onClick={() => togglePostModal()}>{patient !== '' ? patientName : 'Selecione um paciente'}</button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Data do Atendimento *</label>
                                                            <input value={date} onChange={e => setDate(e.target.value)} type="date" className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Procedimento *</label>
                                                            <select value={procedure} onChange={e => setProcedure(e.target.value)} className="form-select" aria-label="Default select example">
                                                                <option selected value="">Selecione um procedimento</option>
                                                                <option value="Consulta">Consulta</option>
                                                                <option value="Laudo">Laudo</option>
                                                                <option value="Retorno">Retorno</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Honorário *</label>
                                                            <NumberFormat
                                                                value={fee}
                                                                onChange={e => setFee(e.target.value)}
                                                                thousandSeparator={true}
                                                                prefix="R$"
                                                                className="form-control"
                                                                inputmode="numeric"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Forma de pagamento *</label>
                                                            <select value={formOfPayment} onChange={e => setFormOfPayment(e.target.value)} className="form-select" aria-label="Default select example">
                                                                <option selected value="">Selecione uma forma</option>
                                                                <option value="Dinheiro">Dinheiro</option>
                                                                <option value="Pix">Pix</option>
                                                                <option value="C.Crédito">C.Crédito</option>
                                                                <option value="C.Débito">C.Débito</option>
                                                                <option value="A faturar">A faturar</option>
                                                                <option value="Cortesia">Cortesia</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Empresa</label>
                                                            <input value={company} onChange={e => setCompany(e.target.value)} type="text" className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">CID *</label>
                                                            <select value={cid} onChange={e => setCid(e.target.value)} className="form-select" aria-label="Default select example">
                                                                <option selected value="">Selecione um CID</option>
                                                                <option value="CID 1">CID 1</option>
                                                                <option value="CID 2">CID 2</option>
                                                                <option value="CID 3">CID 3</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Anotação Médica *</label>
                                                            <textarea className="form-control" value={annotation} onChange={e => setAnnotation(e.target.value)} placeholder="Anote aqui" rows="3" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Relatório Médico *</label>
                                                            <textarea className="form-control" value={report} onChange={e => setReport(e.target.value)} placeholder="Anote aqui" rows="3" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Médico *</label>
                                                            <select value={doctor} onChange={e => setDoctor(e.target.value)} className="form-select" aria-label="Default select example">
                                                                <option selected value="">Selecione uma médico</option>
                                                                <option value="Dr. João">Dr.João</option>
                                                                <option value="Dr. Rafael">Dr.Rafael</option>
                                                                <option value="Dra. Eni">Dra.Eni</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-center mt-3">
                                            <button type="submit" className="btn btn-primary">Cadastrar</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>

                    <Footer />

                </div>

            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
        </>
    )
}

export default NewTreatment
